import { httpClient } from '@/core/api/http-client';

import type { AnalyticsSummary } from './analytics.types';

export const analyticsService = {
  /**
   * Returns the analytics summary for the current period from the real API.
   * Endpoint: GET /admin/analytics
   */
  getSummary: async (): Promise<AnalyticsSummary> => {
    const response = await httpClient.get<AnalyticsSummary>('/admin/analytics');
    return response.data;
  },
};
